module.exports = __webpack_public_path__ + "static/media/ranking.8bf15539.svg";